import React from 'react';
import {styled} from 'styled-components';
import {StyledProps} from '../../modules/common/styles';
import {PromoData} from './promo-data';
import {H1} from '../headings';
import {PromoDetailsBox} from './promo-details-box';
import {PromoContainer} from './promo-container';

interface Props {
    promoData: PromoData;
    showBottomBorder?: boolean;
    showTopBorder?: boolean;
}

// We need the more info title to look like an h1, but in reality it's an h2.
export const MoreInfoTitle = styled(H1).attrs(() => ({as: 'h2'}))``;

const unstyledPromoDetails = (props: Props & StyledProps): JSX.Element => {
    const {className, promoData} = props;

    const {title, promoDetails, fullTermsURL} = promoData;

    return (
        <div className={className}>
            <PromoContainer>
                <MoreInfoTitle>{title}</MoreInfoTitle>
                <PromoDetailsBox
                    promoDetails={promoDetails}
                    fullTermsURL={fullTermsURL}
                />
            </PromoContainer>
        </div>
    );
};

export const PromoDetailsComponent = styled(unstyledPromoDetails)`
    color: ${(props): string => props.theme.colors.ballena};

    border-bottom: ${(props): string =>
        props.showBottomBorder
            ? `1px solid ${props.theme.colors.caballa};`
            : undefined};
    border-top: ${(props): string =>
        props.showTopBorder
            ? `1px solid ${props.theme.colors.caballa};`
            : undefined};

    h2:first-child {
        margin: 48px 0;
        line-height: 1.25;
    }
`;
